define('presentation/reactivation/validators/reactivationValidator',[
    'constants/creditCardResponseConstants',
    'presentation/common/validation/commonValidator',
    'presentation/common/validation/validationRule',
], function () {
    return function () {
        const self = this;

        const CommonValidatorConstructor = require('presentation/common/validation/commonValidator');
        const ValidationRulesConstructor = require('presentation/common/validation/validationRule');

        let _commonValidator = null;
        let _viewModel = null;

        const _validateCustomerAgreesToPay = (customerAgreesToPay) => {
            if (_viewModel.hasPastDueBalance() && _viewModel.isBilledByCreditCard()) {
                return customerAgreesToPay;
            }
            return true;
        };

        self.registerViewModel = (viewModel) => {
            const validationRules = new ValidationRulesConstructor();
            validationRules.field("customerAgreesToPay")
                .addValidationI18n(_validateCustomerAgreesToPay, 'reactivation:acknowledgementRequired');

            _commonValidator = new CommonValidatorConstructor(viewModel, validationRules);
            _viewModel = viewModel;
        };

        self.validate = () => {
            return _commonValidator.validate();
        };
    };
});

